import { Observable } from 'rxjs';
import { ReceiptRepository } from '../domain/receipts/repository';
import { Receipt, ReceiptType } from '../domain/receipts/model';
import HttpClient from '../utils/http-client';

export class ReceiptRepositoryImplementation extends ReceiptRepository {
  private httpClient: HttpClient;

  constructor(uid: string, cid: string | null) {
    super();
    this.httpClient = new HttpClient(uid, cid);
  }

  createReceipt(receipt: Partial<Receipt>): Observable<Receipt> {
    return this.httpClient.post('/receipts', receipt);
  }

  getReceipt(id: number): Observable<any> {
    return this.httpClient.get(`/receipts/${id}`);
  }

  getReceipts(page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/receipts?page=${page}&limit=${limit}`);
  }

  updateReceipt(id: number, receipt: Partial<Receipt>): Observable<Receipt> {
    return this.httpClient.put(`/receipts/${id}`, receipt);
  }

  deleteReceipt(id: number): Observable<void> {
    return this.httpClient.delete(`/receipts/${id}`);
  }

  createReceiptType(receiptType: Partial<ReceiptType>): Observable<ReceiptType> {
    return this.httpClient.post('/receipt-types', receiptType);
  }

  getReceiptType(id: number): Observable<any> {
    return this.httpClient.get(`/receipt-types/${id}`);
  }

  getReceiptTypes(page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/receipt-types?page=${page}&limit=${limit}`);
  }

  updateReceiptType(id: number, receiptType: Partial<ReceiptType>): Observable<ReceiptType> {
    return this.httpClient.put(`/receipt-types/${id}`, receiptType);
  }

  deleteReceiptType(id: number): Observable<void> {
    return this.httpClient.delete(`/receipt-types/${id}`);
  }
}
